import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { subscribeToCountsRealtime, incrementCount } from "../utils/countsService";
import { saveDownloadHistory } from "../utils/historyService";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";

function Form135() {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  // Creator Name (dropdown) — sourced from frontend only
  const [creatorName, setCreatorName] = useState("Chaitra");
  // Tracking Number — sourced from frontend only
  const [trackingNumber, setTrackingNumber] = useState("");
  // Per-button 3s click locks to prevent multiple rapid presses
  const [isLockForm1, setIsLockForm1] = useState(false);
  const [isLockForm3, setIsLockForm3] = useState(false);
  const [isLockForm5, setIsLockForm5] = useState(false);
  const [isLockForm28, setIsLockForm28] = useState(false);
  const form1LockRef = React.useRef(false);
  const form3LockRef = React.useRef(false);
  const form5LockRef = React.useRef(false);
  const form28LockRef = React.useRef(false);

  useEffect(() => {
    // Subscribe to real-time Firebase Firestore updates for counts
    const unsubscribe = subscribeToCountsRealtime((data) => {
      setCounts(data);
    });

    // Cleanup: unsubscribe when component unmounts
    return () => unsubscribe();
  }, []);
  // Section 1: Type Of Application
  const [typeOfApplication, setTypeOfApplication] = useState("Ordinary");

  // Section 2: Applicants
  const [applicants, setApplicants] = useState([
    { name: "", nationality: "IN", country: "IN", address: "" },
  ]);
  const addApplicant = () =>
    setApplicants((prev) => [
      ...prev,
      { name: "", nationality: "IN", country: "IN", address: "" },
    ]);
  const handleApplicantChange = (idx, field, value) => {
    setApplicants((prev) =>
      prev.map((a, i) => (i === idx ? { ...a, [field]: value } : a))
    );
  };
  const removeApplicant = (idx) =>
    setApplicants((prev) => prev.filter((_, i) => i !== idx));

  // Section 3: Category of Applicant
  const [category, setCategory] = useState("");

  // Section 4: Are inventors same as Applicants?
  const [inventorsSame, setInventorsSame] = useState("yes");

  // Section 5: Inventor Details (if not same)
  const [inventors, setInventors] = useState([
    { name: "", gender: "", nationality: "IN", country: "IN", address: "" },
  ]);
  const addInventor = () =>
    setInventors((prev) => [
      ...prev,
      { name: "", gender: "", nationality: "IN", country: "IN", address: "" },
    ]);
  const handleInventorChange = (idx, field, value) => {
    setInventors((prev) =>
      prev.map((a, i) => (i === idx ? { ...a, [field]: value } : a))
    );
  };
  const removeInventor = (idx) =>
    setInventors((prev) => prev.filter((_, i) => i !== idx));

  // Section 6: Title of the Invention
  const [title, setTitle] = useState("");

  // Section 7: PCT Status
  const [pctStatus, setPctStatus] = useState("no");
  const [pctAppNumber, setPctAppNumber] = useState("");
  const [pctInternationalFilingDate, setPctInternationalFilingDate] = useState("");

  // Section 8: Date Of Filing
  const [filingDate, setFilingDate] = useState("");

  // Section 9: Attachments
  const [attachments, setAttachments] = useState({
    specificationType: "Provisional Specification",
    specificationPages: "",
    claims: "0",
    claimsPages: "0",
    abstractPages: "",
    drawings: "",
    drawingsPages: "",
  });
  // Remove any localStorage persistence of form inputs — use live state only
  const handleStepper = (field, delta) => {
    setAttachments((a) => {
      const val = parseInt(a[field] || "0", 10);
      let newVal = isNaN(val) ? 0 : val + delta;
      if (newVal < 0) newVal = 0;
      // If Provisional Specification, claims and claimsPages always 0
      if (
        a.specificationType === "Provisional Specification" &&
        (field === "claims" || field === "claimsPages")
      ) {
        return { ...a, claims: "0", claimsPages: "0" };
      }
      return { ...a, [field]: newVal.toString() };
    });
  };

  // When specificationType changes, reset claims and claimsPages if Provisional
  const handleSpecificationTypeChange = (type) => {
    setAttachments((a) => {
      if (type === "Provisional Specification") {
        return { ...a, specificationType: type, claims: "0", claimsPages: "0" };
      }
      return { ...a, specificationType: type };
    });
  };

  // Validation function
  const isFormValid = () => {
    // Section 1: Type Of Application
    if (!typeOfApplication) return false;

    // Section 2: Applicants
    if (
      applicants.length === 0 ||
      applicants.some(
        (a) =>
          !a.name.trim() ||
          !a.nationality.trim() ||
          !a.country.trim() ||
          !a.address.trim()
      )
    )
      return false;

    // Section 3: Category of Applicant
    if (!category) return false;

    // Section 4: Are inventors same as Applicants?
    if (!inventorsSame) return false;

    // Section 5: Inventor Details (if not same)
    if (
      inventorsSame === "no" &&
      (inventors.length === 0 ||
        inventors.some(
          (inv) =>
            !inv.name.trim() ||
            !inv.gender.trim() ||
            !inv.nationality.trim() ||
            !inv.country.trim() ||
            !inv.address.trim()
        ))
    )
      return false;

    // Section 6: Title of the Invention
    if (!title.trim()) return false;

    // Section 7: PCT Status
    if (!pctStatus) return false;
    if (pctStatus === "yes" && !pctAppNumber.trim()) return false;
    if (pctStatus === "yes" && !pctInternationalFilingDate) return false;

    // Section 8: Date Of Filing
    if (!filingDate) return false;

    // Section 9: Attachments
    if (
      !attachments.specificationType ||
      !attachments.specificationPages ||
      !attachments.claims ||
      !attachments.claimsPages ||
      !attachments.abstractPages ||
      !attachments.drawings ||
      !attachments.drawingsPages
    )
      return false;

    // All checks passed
    return true;
  };

  const handleDownloadForm1 = async () => {
    // Prevent rapid re-clicks within 3 seconds
    if (form1LockRef.current) return;

    if (!isFormValid()) {
      alert("Please fill all required fields before downloading the form.");
      return;
    }

    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number before downloading.");
      return;
    }

    // Check if user is authenticated
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    // Engage 3s lock once validations/auth pass
    form1LockRef.current = true;
    setIsLockForm1(true);
    setTimeout(() => {
      form1LockRef.current = false;
      setIsLockForm1(false);
    }, 3000);

    let newCount;
    try {
      // Increment count in Firestore
      newCount = await incrementCount("FORM1.docx");
      setCounts((c) => ({ ...c, "FORM1.docx": newCount }));
      
      // Save download history: use selected creator name
      const historyCreator = creatorName || "Unknown";
      const patentId = pctAppNumber || "N/A";
      const applicantName = applicants && applicants[0] ? applicants[0].name : null;
      await saveDownloadHistory(historyCreator, patentId, "FORM1.docx", trackingNumber, applicantName);
    } catch (err) {
      alert("Error updating download count: " + err.message);
      return;
    }

    // Fetch the template from public folder
    let response, arrayBuffer, zip, doc;
    try {
      response = await fetch("/FORM1.docx", { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`Failed to fetch template: ${response.status} ${response.statusText}`);
      }
      arrayBuffer = await response.arrayBuffer();
      zip = new PizZip(arrayBuffer);
      doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });
    } catch (error) {
      alert("Error loading template file: " + error.message);
      return;
    }

    // Prepare data for docxtemplater
    const signatureDate = formatDateFancy(filingDate);
    // Pick inventors or applicants for signature block
    const signatureBlock = (
      inventorsSame === "yes" ? applicants : inventors
    ).map((person, idx) => ({
      signatureLabel: idx === 0 ? "Signature (s)" : "Signatures (s)",
      nameLabel: idx === 0 ? "Name(s):" : "Name :",
      dateLabel: idx === 0 ? "Date:" : "Date :",
      name: person.name,
      date: signatureDate,
    }));
    const data = {
      // Radio helpers (booleans for {#...}√{/...}{^...}{/...})
      ...getTypeOfApplicationReplacements(typeOfApplication),
      ...getCategoryReplacements(category),
      ...getInventorsSameReplacements(inventorsSame),
      ...getPctStatusReplacements(pctStatus),
      // Other fields
      title,
      pctAppNumber,
      pctAppNumberFinal: pctStatus === "yes" ? pctAppNumber : "Not Applicable",
      formattedFilingDate: formatDateFancy(filingDate),
      filingDate,
      applicants,
      inventors: inventorsSame === "no" ? inventors : applicants,
      // Attachments breakdown for template tags
      specificationType: getSpecificationType(attachments.specificationType),
      specificationPages: attachments.specificationPages,
      claims: attachments.claims,
      claimsPages: attachments.claimsPages,
      abstractPages: attachments.abstractPages,
      drawings: attachments.drawings,
      drawingsPages: attachments.drawingsPages,
      attachments,
      signatureBlock,
    };

    try {
      doc.render(data);
      const out = doc.getZip().generate({ type: "blob" });
      saveAs(out, "FORM1-filled.docx");
      // Use the returned newCount from incrementCount
      const currentCount = newCount || 1;
      alert(`This form has been downloaded ${currentCount} ${currentCount === 1 ? 'time' : 'times'}`);
    } catch (error) {
      alert("Error generating document: " + error.message);
    }
  };

  // Helper for docx template replacement (for document generation)
  // For docxtemplater logic: {#agree}√{/agree}{^agree}{/agree}
  const getTypeOfApplicationReplacements = (typeOfApplication) => {
    return {
      Ordinary: typeOfApplication === "Ordinary",
      Convention: typeOfApplication === "Convention",
      "PCT-NP": typeOfApplication === "PCT-NP",
      PPH: typeOfApplication === "PPH",
    };
  };
  // Example for other radios (add similar helpers as needed):
  const getCategoryReplacements = (category) => {
    return {
      np: category === "Natural Person",
      onp: category === "Other than Natural Person",
      se: category === "Small Entity",
      su: category === "Startup",
      ei: category === "Educational Institution",
      oth: category === "Others",
    };
  };
  const getInventorsSameReplacements = (inventorsSame) => {
    return {
      invagree: inventorsSame === "yes",
      invdisagree: inventorsSame === "no",
    };
  };
  const getPctStatusReplacements = (pctStatus) => {
    return {
      agree: pctStatus === "yes",
      disagree: pctStatus === "no",
    };
  };
  const getSpecificationType = (specType) => {
    return specType === "Provisional Specification"
      ? "Provisional"
      : "Complete";
  };

  // Format date as '6th day of July, 2025' or 'Not Provided'
  const formatDateFancy = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return "Not Provided";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return `${n}th`;
      const suffix = ["st", "nd", "rd"][(n % 10) - 1] || "th";
      return `${n}${suffix}`;
    };

    return `${getOrdinal(day)} day of ${month}, ${year}`;
  };

  //Form3

  const handleDownloadForm3 = async () => {
    if (form3LockRef.current) return;
    if (!applicants.length || !filingDate) {
      alert("Please fill applicants and filing date before downloading Form 3.");
      return;
    }

    const token3 = localStorage.getItem("access_token");
    if (!token3) {
      navigate("/login");
      return;
    }

    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number before downloading.");
      return;
    }

    form3LockRef.current = true;
    setIsLockForm3(true);
    setTimeout(() => {
      form3LockRef.current = false;
      setIsLockForm3(false);
    }, 3000);

    let newCount;
    try {
      // Increment count in Firestore
      newCount = await incrementCount("FORM3.docx");
      setCounts((c) => ({ ...c, "FORM3.docx": newCount }));
      
      // Save download history: use selected creator name
      const historyCreator = creatorName || "Unknown";
      const patentId = pctAppNumber || "N/A";
      const applicantName = applicants && applicants[0] ? applicants[0].name : null;
      await saveDownloadHistory(historyCreator, patentId, "FORM3.docx", trackingNumber, applicantName);
    } catch (err) {
      alert("Error updating download count: " + err.message);
      return;
    }

    const response = await fetch("/FORM3.docx", { cache: "no-store" });
    const arrayBuffer = await response.arrayBuffer();
    const zip = new PizZip(arrayBuffer);
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });

    const data = {
      applicants,
      formattedFilingDate: formatDateFancy(filingDate),
    };

    try {
      doc.render(data);
      const blob = doc.getZip().generate({ type: "blob" });
      saveAs(blob, "FORM3-filled.docx");
      // Use the returned newCount from incrementCount
      const currentCount = newCount || 1;
      alert(`This form has been downloaded ${currentCount} ${currentCount === 1 ? 'time' : 'times'}`);
    } catch (error) {
      alert("Error generating Form3: " + error.message);
    }
  };

  //Form5
  const handleDownloadForm5 = async () => {
    if (form5LockRef.current) return;
    if (!applicants.length || !filingDate) {
      alert("Please fill applicants and filing date before downloading Form 5.");
      return;
    }

    const token5 = localStorage.getItem("access_token");
    if (!token5) {
      navigate("/login");
      return;
    }

    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number before downloading.");
      return;
    }

    form5LockRef.current = true;
    setIsLockForm5(true);
    setTimeout(() => {
      form5LockRef.current = false;
      setIsLockForm5(false);
    }, 3000);

    let newCount;
    try {
      // Increment count in Firestore
      newCount = await incrementCount("FORM5.docx");
      setCounts((c) => ({ ...c, "FORM5.docx": newCount }));
      
      // Save download history: use selected creator name
      const historyCreator = creatorName || "Unknown";
      const patentId = pctAppNumber || "N/A";
      const applicantName = applicants && applicants[0] ? applicants[0].name : null;
      await saveDownloadHistory(historyCreator, patentId, "FORM5.docx", trackingNumber, applicantName);
    } catch (err) {
      alert("Error updating download count: " + err.message);
      return;
    }

    const response = await fetch("/FORM5.docx", { cache: "no-store" });
    const arrayBuffer = await response.arrayBuffer();
    const zip = new PizZip(arrayBuffer);

    // Compute flags and specification phrase early so we can patch the
    // DOCX XML if the template contains the hardcoded words.
    const inventorsSameFlag = inventorsSame;
    const specType = attachments.specificationType;
    const specificationPhrase =
      specType === "Provisional Specification"
        ? "provisional Specification"
        : "complete Specification";

    try {
      const file = zip.file("word/document.xml");
      if (file) {
        let xml;
        if (typeof file.asText === "function") {
          xml = file.asText();
        } else if (typeof file.async === "function") {
          xml = await file.async("string");
        }
        if (xml) {
          xml = xml
            .replace(/provisional Specification/g, specificationPhrase)
            .replace(/complete Specification/g, specificationPhrase);
          zip.file("word/document.xml", xml);
        }
      }
    } catch (e) {
      console.warn("Could not patch DOCX XML for specification phrase", e);
    }

    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });

    let data;
    if (inventorsSameFlag === "yes" || inventorsSameFlag === true) {
      data = {
        applicants,
        inventors: applicants,
        invagree: true,
        invdisagree: false,
        specificationPhrase,
        formattedFilingDate: formatDateFancy(filingDate),
      };
    } else {
      const inventorsList = inventors && inventors.length ? inventors : applicants;
      data = {
        applicants,
        inventors: inventorsList,
        invagree: false,
        invdisagree: true,
        specificationPhrase,
        formattedFilingDate: formatDateFancy(filingDate),
      };
    }

    try {
      doc.render(data);
      const blob = doc.getZip().generate({ type: "blob" });
      saveAs(blob, "FORM5-filled.docx");
      // Use the returned newCount from incrementCount
      const currentCount = newCount || 1;
      alert(`This form has been downloaded ${currentCount} ${currentCount === 1 ? 'time' : 'times'}`);
    } catch (error) {
      alert("Error generating Form5: " + error.message);
    }
  };

  //Form28
  const handleDownloadForm28 = async () => {
    if (form28LockRef.current) {
      return;
    }
    // Check PCT status requirement
    if (pctStatus !== "yes") {
      alert("Form 28 is only available when PCT Status is 'Yes'.");
      return;
    }
    if (!pctAppNumber.trim() || !pctInternationalFilingDate) {
      alert("Please fill in both Application Number and International Filing Date before downloading Form 28.");
      return;
    }
    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number before downloading.");
      return;
    }
    if (!applicants.length || !filingDate) {
      alert("Please fill applicants and filing date before downloading Form 28.");
      return;
    }
    form28LockRef.current = true;
    setIsLockForm28(true);
    setTimeout(() => {
      form28LockRef.current = false;
      setIsLockForm28(false);
    }, 3000);
    const token28 = localStorage.getItem("access_token");
    if (!token28) {
      navigate("/login");
      return;
    }
    let newCount;
    try {
      newCount = await incrementCount("FORM28.docx");
      setCounts((c) => ({ ...c, "FORM28.docx": newCount }));
      const historyCreator = creatorName || "Unknown";
      const patentId = pctAppNumber || "N/A";
      const applicantName = applicants && applicants[0] ? applicants[0].name : null;
      await saveDownloadHistory(historyCreator, patentId, "FORM28.docx", trackingNumber, applicantName);
    } catch (err) {
      alert("Error updating download count: " + err.message);
      return;
    }
    try {
      const response = await fetch(`/FORM 28.docx?v=${Date.now()}`);
      if (!response.ok) {
        throw new Error("Failed to load template");
      }
      const arrayBuffer = await response.arrayBuffer();
      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });
      const firstApplicant = applicants && applicants[0]
          ? applicants[0]
          : { name: "", nationality: "", address: "" };
      doc.setData({
        name: firstApplicant.name || "[Name]",
        nationality: firstApplicant.nationality || "[Nationality]",
        address: firstApplicant.address || "[Address]",
        patent_id: pctAppNumber || "[Patent ID]",
        patent_date: formatDateFancy(pctInternationalFilingDate) || "[International Filing Date]",
        formattedFilingDate: formatDateFancy(filingDate) || "[Date of Filing]",
        pctAppNumber: pctAppNumber || "[PCT Application Number]",
        pctInternationalFilingDate: formatDateFancy(pctInternationalFilingDate) || "[International Filing Date]",
      });
      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      saveAs(output, `Form28_${firstApplicant.name || "document"}.docx`);
      const currentCount = newCount || 1;
      alert(`This form has been downloaded ${currentCount} ${currentCount === 1 ? 'time' : 'times'}`);
    } catch (error) {
      console.error("Error generating document:", error);
      alert("Failed to generate document. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <div className="max-w-3xl mx-auto mt-10 bg-white p-8 rounded-xl shadow-lg border border-gray-200 flex flex-col gap-8">
        {/* Form Generator Title */}
        <div className="text-center border-b-2 border-blue-200 pb-4 mb-2">
          <h1 className="text-3xl md:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400 mb-2">
            Patent Form Generator
          </h1>
          <p className="text-gray-600 text-sm">
            Fill in the details below to generate patent forms automatically
          </p>
          {/* Creator Name & Tracking Number (required) */}
          <div className="mt-4 flex flex-col items-center gap-2">
            <label className="text-sm font-semibold text-gray-700">Creator Name <span className="text-red-600">*</span></label>
            <select
              className="border-2 border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full max-w-md"
              value={creatorName}
              onChange={(e) => setCreatorName(e.target.value)}
            >
              <option value="Chaitra">Chaitra</option>
              <option value="Mounisha">Mounisha</option>
              <option value="Lextria">Lextria</option>
            </select>
            <label className="text-sm font-semibold text-gray-700">Tracking Number <span className="text-red-600">*</span></label>
            <input
              type="text"
              placeholder="Enter tracking number"
              className="border-2 border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full max-w-md"
              value={trackingNumber}
              onChange={(e) => setTrackingNumber(e.target.value)}
            />
          </div>
        </div>
        
        {/* Section 1 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Type Of Application <span className="text-red-600">*</span>
          </h2>
          <div className="flex flex-wrap gap-4 justify-center">
            {["Ordinary", "Convention", "PCT-NP", "PPH"].map((type) => (
              <label
                key={type}
                className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                  typeOfApplication === type
                    ? "bg-blue-100 border-blue-500"
                    : "bg-gray-50 border-gray-200 hover:border-blue-300"
                }`}
              >
                <input
                  type="radio"
                  name="typeOfApplication"
                  value={type}
                  checked={typeOfApplication === type}
                  onChange={() => setTypeOfApplication(type)}
                  className="mr-2 accent-blue-600"
                />
                <span className="font-medium">{type}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Section 2 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Applicant(s) <span className="text-red-600">*</span>
          </h2>
          <div className="flex flex-col gap-4">
            {applicants.map((a, idx) => (
              <div
                key={idx}
                className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center bg-gray-50 p-4 rounded-lg border border-gray-200"
              >
                <input
                  type="text"
                  placeholder="Name"
                  className="border p-2 rounded focus:outline-blue-400 w-full"
                  value={a.name}
                  onChange={(e) =>
                    handleApplicantChange(idx, "name", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Nationality"
                  className="border p-2 rounded focus:outline-blue-400 w-full"
                  value={a.nationality}
                  onChange={(e) =>
                    handleApplicantChange(idx, "nationality", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Country Of Residence"
                  className="border p-2 rounded focus:outline-blue-400 w-full"
                  value={a.country}
                  onChange={(e) =>
                    handleApplicantChange(idx, "country", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Address"
                  className="border p-2 rounded focus:outline-blue-400 w-full"
                  value={a.address}
                  onChange={(e) =>
                    handleApplicantChange(idx, "address", e.target.value)
                  }
                />
                {applicants.length > 1 && (
                  <button
                    onClick={() => removeApplicant(idx)}
                    className="text-red-600 col-span-1 md:col-span-4 text-left text-sm underline hover:text-red-800 mt-2"
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              onClick={addApplicant}
              className="bg-green-600 text-white px-4 py-2 rounded-lg mt-1 mb-2 hover:bg-green-700 transition self-center"
            >
              + Add Applicant
            </button>
          </div>
        </div>

        {/* Section 3 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Category of Applicant <span className="text-red-600">*</span>
          </h2>
          <div className="flex flex-wrap gap-4 justify-center">
            {[
              "Natural Person",
              "Other than Natural Person",
              "Small Entity",
              "Startup",
              "Educational Institution",
              "Others",
            ].map((cat) => (
              <label
                key={cat}
                className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                  category === cat
                    ? "bg-blue-100 border-blue-500"
                    : "bg-gray-50 border-gray-200 hover:border-blue-300"
                }`}
              >
                <input
                  type="radio"
                  name="category"
                  value={cat}
                  checked={category === cat}
                  onChange={() => setCategory(cat)}
                  className="mr-2 accent-blue-600"
                />
                <span className="font-medium">{cat}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Section 4 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Are the inventors same as Applicants? <span className="text-red-600">*</span>
          </h2>
          <div className="flex gap-6 justify-center">
            <label
              className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                inventorsSame === "yes"
                  ? "bg-blue-100 border-blue-500"
                  : "bg-gray-50 border-gray-200 hover:border-blue-300"
              }`}
            >
              <input
                type="radio"
                name="inventorsSame"
                value="yes"
                checked={inventorsSame === "yes"}
                onChange={() => setInventorsSame("yes")}
                className="mr-2 accent-blue-600"
              />
              Yes
            </label>
            <label
              className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                inventorsSame === "no"
                  ? "bg-blue-100 border-blue-500"
                  : "bg-gray-50 border-gray-200 hover:border-blue-300"
              }`}
            >
              <input
                type="radio"
                name="inventorsSame"
                value="no"
                checked={inventorsSame === "no"}
                onChange={() => setInventorsSame("no")}
                className="mr-2 accent-blue-600"
              />
              No
            </label>
          </div>
        </div>

        {/* Section 5: Inventor Details if not same */}
        {inventorsSame === "no" && (
          <div className="mb-2">
            <h2 className="text-lg font-semibold mb-2 text-blue-600 text-center">
              Inventor Details <span className="text-red-600">*</span>
            </h2>
            <div className="flex flex-col gap-4">
              {inventors.map((inv, idx) => (
                <div
                  key={idx}
                  className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center bg-gray-50 p-4 rounded-lg border border-gray-200"
                >
                  <input
                    type="text"
                    placeholder="Name"
                    className="border p-2 rounded focus:outline-blue-400 w-full"
                    value={inv.name}
                    onChange={(e) =>
                      handleInventorChange(idx, "name", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Gender"
                    className="border p-2 rounded focus:outline-blue-400 w-full"
                    value={inv.gender}
                    onChange={(e) =>
                      handleInventorChange(idx, "gender", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Nationality"
                    className="border p-2 rounded focus:outline-blue-400 w-full"
                    value={inv.nationality}
                    onChange={(e) =>
                      handleInventorChange(idx, "nationality", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Country of Residence"
                    className="border p-2 rounded focus:outline-blue-400 w-full"
                    value={inv.country}
                    onChange={(e) =>
                      handleInventorChange(idx, "country", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Address"
                    className="border p-2 rounded focus:outline-blue-400 w-full"
                    value={inv.address}
                    onChange={(e) =>
                      handleInventorChange(idx, "address", e.target.value)
                    }
                  />
                  {inventors.length > 1 && (
                    <button
                      onClick={() => removeInventor(idx)}
                      className="text-red-600 col-span-1 md:col-span-5 text-left text-sm underline hover:text-red-800 mt-2"
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={addInventor}
                className="bg-green-600 text-white px-4 py-2 rounded-lg mt-1 hover:bg-green-700 transition self-center"
              >
                + Add Inventor
              </button>
            </div>
          </div>
        )}

        {/* Section 6 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Title of the Invention <span className="text-red-600">*</span>
          </h2>
          <input
            type="text"
            placeholder="Enter title here"
            className="border p-2 w-full rounded focus:outline-blue-400 mb-2"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* Section 7 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            PCT Status <span className="text-red-600">*</span>
          </h2>
          <div className="flex gap-6 items-center justify-center">
            <label
              className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                pctStatus === "yes"
                  ? "bg-blue-100 border-blue-500"
                  : "bg-gray-50 border-gray-200 hover:border-blue-300"
              }`}
            >
              <input
                type="radio"
                name="pctStatus"
                value="yes"
                checked={pctStatus === "yes"}
                onChange={() => setPctStatus("yes")}
                className="mr-2 accent-blue-600"
              />
              Yes
            </label>
            <label
              className={`flex items-center px-4 py-2 rounded-lg cursor-pointer border transition-colors ${
                pctStatus === "no"
                  ? "bg-blue-100 border-blue-500"
                  : "bg-gray-50 border-gray-200 hover:border-blue-300"
              }`}
            >
              <input
                type="radio"
                name="pctStatus"
                value="no"
                checked={pctStatus === "no"}
                onChange={() => setPctStatus("no")}
                className="mr-2 accent-blue-600"
              />
              No
            </label>
          </div>
          {pctStatus === "yes" && (
            <div className="mt-4 space-y-4">
              <div className="flex flex-col items-center">
                <label className="text-sm font-semibold text-gray-700 mb-2">
                  Application Number <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Application Number"
                  className="border-2 border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full max-w-md"
                  value={pctAppNumber}
                  onChange={(e) => setPctAppNumber(e.target.value)}
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-sm font-semibold text-gray-700 mb-2">
                  International Filing Date <span className="text-red-600">*</span>
                </label>
                <input
                  type="date"
                  className="border-2 border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full max-w-md"
                  value={pctInternationalFilingDate}
                  onChange={(e) => setPctInternationalFilingDate(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>

        {/* Section 8 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700">
            Date Of Filing <span className="text-red-600">*</span>
          </h2>
          <div className="flex justify-center">
            <input
              type="date"
              className="border p-2 rounded focus:outline-blue-400 mb-2 w-60 text-center"
              value={filingDate}
              onChange={(e) => setFilingDate(e.target.value)}
            />
          </div>
        </div>

        {/* Section 9 */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-blue-700 text-center">
            Attachments with the application <span className="text-red-600">*</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Specification Type */}
            <div className="flex flex-col gap-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <span className="font-semibold mb-2"> Specification Type <span className="text-red-600">*</span></span> 
              <div className="flex gap-4">
                <label
                  className={`flex items-center px-3 py-1 rounded-lg cursor-pointer border transition-colors ${
                    attachments.specificationType ===
                    "Provisional Specification"
                      ? "bg-blue-100 border-blue-500"
                      : "bg-gray-50 border-gray-200 hover:border-blue-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="specificationType"
                    value="Provisional Specification"
                    checked={
                      attachments.specificationType ===
                      "Provisional Specification"
                    }
                    onChange={() =>
                      handleSpecificationTypeChange("Provisional Specification")
                    }
                    className="mr-2 accent-blue-600"
                  />
                  Provisional Specification
                </label>
                <label
                  className={`flex items-center px-3 py-1 rounded-lg cursor-pointer border transition-colors ${
                    attachments.specificationType === "Complete Specification"
                      ? "bg-blue-100 border-blue-500"
                      : "bg-gray-50 border-gray-200 hover:border-blue-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="specificationType"
                    value="Complete Specification"
                    checked={
                      attachments.specificationType === "Complete Specification"
                    }
                    onChange={() =>
                      handleSpecificationTypeChange("Complete Specification")
                    }
                    className="mr-2 accent-blue-600"
                  />
                  Complete Specification
                </label>
              </div>
              <div className="flex gap-2 mt-2 items-center">
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("specificationPages", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Pages"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.specificationPages}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, specificationPages: val }));
                  }}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("specificationPages", 1)}
                >
                  +
                </button>
              </div>
            </div>
            {/* Claims */}
            <div className="flex flex-col gap-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <span className="font-semibold mb-2">No Of Claims <span className="text-red-600">*</span></span>
              <div className="flex gap-2 items-center">
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("claims", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Claims"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.claims}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, claims: val }));
                  }}
                  readOnly={attachments.specificationType === "Provisional Specification"}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("claims", 1)}
                >
                  +
                </button>
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300 ml-2"
                  onClick={() => handleStepper("claimsPages", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Pages"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.claimsPages}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, claimsPages: val }));
                  }}
                  readOnly={attachments.specificationType === "Provisional Specification"}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("claimsPages", 1)}
                >
                  +
                </button>
              </div>
            </div>
            {/* Abstract */}
            <div className="flex flex-col gap-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <span className="font-semibold mb-2">Abstract <span className="text-red-600">*</span></span>
              <div className="flex gap-2 items-center">
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("abstractPages", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Pages"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.abstractPages}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, abstractPages: val }));
                  }}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("abstractPages", 1)}
                >
                  +
                </button>
              </div>
            </div>
            {/* Drawings */}
            <div className="flex flex-col gap-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <span className="font-semibold mb-2">No Of Drawings <span className="text-red-600">*</span></span>
              <div className="flex gap-2 items-center">
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("drawings", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Drawings"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.drawings}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, drawings: val }));
                  }}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("drawings", 1)}
                >
                  +
                </button>
                <button
                  type="button"
                  aria-label="Decrement"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300 ml-2"
                  onClick={() => handleStepper("drawingsPages", -1)}
                >
                  -
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="No of Pages"
                  className="border p-2 rounded focus:outline-blue-400 w-full text-center"
                  value={attachments.drawingsPages}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAttachments((a) => ({ ...a, drawingsPages: val }));
                  }}
                />
                <button
                  type="button"
                  aria-label="Increment"
                  className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleStepper("drawingsPages", 1)}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
            (!isFormValid() || isLockForm1 || !trackingNumber.trim()) ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleDownloadForm1}
          disabled={!isFormValid() || isLockForm1 || !trackingNumber.trim()}
          aria-disabled={!isFormValid() || isLockForm1 || !trackingNumber.trim()}
          style={{ pointerEvents: (!isFormValid() || isLockForm1 || !trackingNumber.trim()) ? "none" : undefined }}
        >
          <div className="flex items-center justify-between w-full">
            <span className="text-white">Download Form1</span>
            <span className="ml-3 bg-white text-sm text-gray-800 px-2 py-1 rounded-full border">
              {counts && counts['FORM1.docx'] != null ? counts['FORM1.docx'] : 0}
            </span>
          </div>
        </button>

        <button
          className={`bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
            (!isFormValid() || isLockForm3 || !trackingNumber.trim()) ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleDownloadForm3}
          disabled={!isFormValid() || isLockForm3 || !trackingNumber.trim()}
          aria-disabled={!isFormValid() || isLockForm3 || !trackingNumber.trim()}
          // prevent pointer events when visually disabled
          style={{ pointerEvents: (!isFormValid() || isLockForm3 || !trackingNumber.trim()) ? "none" : undefined }}
        >
          <div className="flex items-center justify-between w-full">
            <span className="text-white">Download Form3</span>
            <span className="ml-3 bg-white text-sm text-gray-800 px-2 py-1 rounded-full border">
              {counts && counts['FORM3.docx'] != null ? counts['FORM3.docx'] : 0}
            </span>
          </div>
        </button>
        <button
          className={`bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
            (!isFormValid() || isLockForm5 || !trackingNumber.trim()) ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleDownloadForm5}
          disabled={!isFormValid() || isLockForm5 || !trackingNumber.trim()}
          aria-disabled={!isFormValid() || isLockForm5 || !trackingNumber.trim()}
          style={{ pointerEvents: (!isFormValid() || isLockForm5 || !trackingNumber.trim()) ? "none" : undefined }}
        >
          <div className="flex items-center justify-between w-full">
            <span className="text-white">Download Form5</span>
            <span className="ml-3 bg-white text-sm text-gray-800 px-2 py-1 rounded-full border">
              {counts && counts['FORM5.docx'] != null ? counts['FORM5.docx'] : 0}
            </span>
          </div>
        </button>
        
        <button
          className={`bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
            (!isFormValid() || pctStatus !== "yes" || !pctAppNumber.trim() || !pctInternationalFilingDate || isLockForm28 || !trackingNumber.trim()) ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleDownloadForm28}
          disabled={!isFormValid() || pctStatus !== "yes" || !pctAppNumber.trim() || !pctInternationalFilingDate || isLockForm28 || !trackingNumber.trim()}
          aria-disabled={!isFormValid() || pctStatus !== "yes" || !pctAppNumber.trim() || !pctInternationalFilingDate || isLockForm28 || !trackingNumber.trim()}
          style={{ pointerEvents: (!isFormValid() || pctStatus !== "yes" || !pctAppNumber.trim() || !pctInternationalFilingDate || isLockForm28 || !trackingNumber.trim()) ? "none" : undefined }}
        >
          <div className="flex items-center justify-between w-full">
            <span className="text-white">Download Form28</span>
            <span className="ml-3 bg-white text-sm text-gray-800 px-2 py-1 rounded-full border">
              {counts && counts['FORM28.docx'] != null ? counts['FORM28.docx'] : 0}
            </span>
          </div>
        </button>
      </div>
    </>
  );
}

export default Form135;
